import { getCoreSonarObjectsSearchSlice } from './get';

export const { requestGetCoreSonarObjectsSearch, resetGetCoreSonarObjectsSearch } =
	getCoreSonarObjectsSearchSlice.asyncActionCreators;
